export const CONTACT = {
    title: "Contact Me",
    subtitle: "My",
    typeWriter: ["Contact"],
    text: "If you have any suggestion, project or even you want to say “hello”, please fill out the form below and I will reply you shortly.",
    location: "Naogaon 6540, Rajshahi,",
    country: "Bangladesh",
    email: "mosabbirahamed8@gmail.com",
    phone: "+880 1754 807456",
}